import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/ui/Button';

/**
 * Understated "free to start" band. Premium apps don't lead with price tables
 * on the landing page — the value comes first, and the detailed plans live at
 * the point of use (the /billing checkout). Here we only reassure: everything
 * is free to try, and the first conference is on us.
 */
const Pricing = ({ isAuthenticated }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('conferences');

  const goStart = () => navigate(isAuthenticated ? '/conference-setup-wizard' : '/user-registration');

  return (
    <section className="relative bg-background border-t border-border py-16 md:py-24 overflow-hidden">
      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div aria-hidden="true" className="mb-1 h-px bg-border" />
        <div aria-hidden="true" className="mb-8 h-px bg-border" />

        <h2 className="font-heading font-bold text-foreground text-[26px] sm:text-[32px] leading-[1.15] mb-4">
          {t('landing.pricing.freeStartTitle')}{' '}
          <span className="italic font-academic font-normal">{t('landing.pricing.freeStartAccent')}</span>
        </h2>

        <p className="font-academic text-[17px] leading-[1.7] text-muted-foreground max-w-2xl mx-auto mb-9">
          {t('landing.pricing.freeStartSubtitle')}
        </p>

        <Button size="lg" onClick={goStart}>
          {isAuthenticated ? t('landing.pricing.createCta') : t('landing.pricing.startCta')}
        </Button>
      </div>
    </section>
  );
};

export default Pricing;
